import { create } from 'zustand';

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'ads-theme';

/**
 * 读取持久化主题,默认 light。初始 class 由 index.html 内联脚本设置以避免闪烁,
 * 这里只同步 React 侧的初始值,不重复操作 DOM。
 */
function readInitialTheme(): Theme {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

function applyTheme(theme: Theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark');
}

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: readInitialTheme(),
  setTheme: (theme) => {
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // 隐私模式等写入失败时忽略,仅本次会话生效
    }
    applyTheme(theme);
    set({ theme });
  },
  toggleTheme: () => get().setTheme(get().theme === 'dark' ? 'light' : 'dark'),
}));
